<template>
  <div class="q-pa-lg column q-gutter-y-md">
    <!-- header -->
    <q-card class="border-card">
      <q-card-section class="l-text-title text-weight-bolder q-pb-none">
        Buat Inbound
      </q-card-section>

      <q-card-section class="l-text-description q-pt-none">
        <q-breadcrumbs class="text-brand" active-color="grey-7" separator=">">
          <q-breadcrumbs-el label="Inbound" />
          <q-breadcrumbs-el label="Buat Inbound" />
        </q-breadcrumbs>
      </q-card-section>
    </q-card>

    <q-card class="border-card">
      <!-- input field -->
      <q-card-section class="column q-gutter-y-sm q-pb-none q-mt-sm">
        <div class="row justify-between" style="width: 100%">
          <div class="col-2 items-center">
            <div style="font-size: 18px">Diterima</div>
          </div>
          <div class="col-4 q-pr-xl">
            <q-input
              clearable
              dense
              outlined
              v-model="data.diterima"
              mask="date"
              @clear="data.diterima = ''"
              :disable="data.isDetail"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer" color="grey-5">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="data.diterima" :options="optDate">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-2 text-left items-center q-pl-md">
            <div style="font-size: 18px">Gudang Asal</div>
          </div>
          <div class="col-4">
            <q-input
              outlined
              dense
              v-model="data.gudang"
              disable
              readonly
              style="width: 100%"
            />
          </div>
        </div>
        <div
          class="row justify-between"
          style="width: 100%; height: 100%; border-radius: 8px"
        >
          <div class="col-2">
            <div style="font-size: 18px">No. Dokumen</div>
          </div>
          <div class="col-4 q-pr-xl">
            <q-input
              v-model="data.noDok"
              outlined
              dense
              style="width: 100%"
              :disable="data.isDetail"
            />
          </div>

          <div class="col-2 text-left q-pl-md">
            <div style="font-size: 18px">Keterangan</div>
          </div>
          <div class="col-4">
            <q-input
              v-model="data.keterangan"
              class="high-input"
              type="textarea"
              outlined
              dense
              :disable="data.isDetail"
            />
          </div>
        </div>
      </q-card-section>

      <!-- button & desc -->
      <q-card-section class="row text-right items-center q-pb-none">
        <div style="font-size: 18px">
          <b>{{ data.rows.length }}</b> Data Artikel
        </div>
        <q-space />
        <q-btn
          class="text-weight-bold"
          no-caps
          unelevated
          color="brand"
          label="Masukkan Artikel"
          @click="openDialog = true"
          :disable="route.params.id_inbound != ''"
        ></q-btn>
      </q-card-section>

      <!-- table content -->
      <q-card-section>
        <q-markup-table flat bordered class="q-mb-md">
          <thead class="bg-grey-2">
            <tr>
              <th class="text-center">No</th>
              <th class="text-center">Artikel</th>
              <th class="text-center">Jml</th>
              <th class="text-center">Ratio</th>
              <th class="text-center">Start Size</th>
              <th class="text-center">Keterangan</th>
              <th class="text-center" v-if="!data.isDetail">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in data.rows" :key="idx">
              <td class="text-center">{{ idx + 1 }}</td>
              <td class="text-left">{{ item.article_code }}</td>
              <td class="text-center">
                <q-input
                  input-class="text-center"
                  type="number"
                  class="q-mx-auto"
                  outlined
                  dense
                  v-model.number="item.qty"
                  style="width: 70%"
                  :disable="data.isDetail"
                />
              </td>
              <td class="text-center">
                <q-btn
                  v-if="!data.isDetail"
                  :label="
                    JSON.stringify(item.ratio) ===
                    JSON.stringify([0, 0, 0, 0, 0, 0].join(''))
                      ? 'Masukkan Ratio'
                      : item.ratio
                  "
                  flat
                  no-caps
                  color="brand"
                  dense
                  @click="dialogRatio(idx)"
                />
                <div v-else>
                  {{ item.ratio }}
                </div>
              </td>
              <td class="text-center">
                <q-input
                  input-class="text-center"
                  type="number"
                  class="q-mx-auto"
                  outlined
                  dense
                  v-model.number="item.starting_size"
                  style="width: 70%"
                  :disable="data.isDetail"
                />
              </td>
              <td class="text-left">
                <q-input
                  outlined
                  dense
                  v-model="item.remarks"
                  style="width: 100%"
                  :disable="data.isDetail"
                />
              </td>
              <td class="text-center" v-if="!data.isDetail">
                <q-btn
                  label="Hapus"
                  flat
                  no-caps
                  color="brand"
                  dense
                  @click="deleteArtikelItem(idx)"
                />
              </td>
            </tr>
          </tbody>
        </q-markup-table>

        <div class="text-center" v-if="data.rows.length == 0">
          <q-img
            :src="`/img/data-masih-kosong.png`"
            class="q-ma-xl"
            width="180px"
          >
          </q-img>
        </div>
      </q-card-section>
    </q-card>

    <q-footer
      class="q-pl-lg q-pr-sm row justify-center"
      style="background-color: #f4f4f4"
      v-if="data.rows.length != 0"
    >
      <div
        class="bg-white q-gutter-x-md row justify-end shadow-box shadow-up-2 q-pa-md"
        style="width: 100%; border-radius: 10px 10px 0 0"
      >
        <q-btn
          class="q-px-md"
          label="Keluar"
          outline
          no-caps
          color="brand"
          dense
          @click="
            data.isDetail ? router.push('/inbound') : (openDialogKeluar = true)
          "
        />
        <q-btn
          v-if="!data.isDetail"
          class="q-px-md"
          label="Simpan"
          no-caps
          color="brand"
          dense
          @click="openDialogSimpan = true"
        />
      </div>
    </q-footer>

    <!-- dialog masukkan artikel -->
    <q-dialog v-model="openDialog">
      <q-card
        class="my-font bg-grey-3 q-pt-md"
        style="max-width: 1500px; width: 1200px"
      >
        <q-card-section horizontal>
          <q-card-section class="col-8 bg-white column q-gutter-y-md">
            <div class="row items-center q-gutter-x-sm">
              <q-input
                dense
                outlined
                v-model="data.cariProduk"
                placeholder="Cari Nama Produk"
                style="width: 40%; height: 40px"
              />
              <q-btn
                unelevated
                icon="search"
                color="brand"
                dense
                @click="
                  data.pagination.current = 1;
                  getListArtikel();
                "
              ></q-btn>
            </div>
            <q-markup-table flat bordered>
              <thead class="bg-grey-2">
                <tr>
                  <th class="text-center">No. Artikel</th>
                  <th class="text-center">Varian</th>
                  <th class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in data.rowsArtikel" :key="idx">
                  <td class="text-center">{{ item.sub_code }}</td>
                  <td class="text-center">{{ item.sub_color }}</td>
                  <td class="text-center">
                    <q-btn
                      label="Tambah"
                      flat
                      no-caps
                      color="brand"
                      dense
                      @click="
                        addArtikel(item.sub_code, item.sub_color, item.image)
                      "
                    />
                  </td>
                </tr>
              </tbody>
            </q-markup-table>
            <div class="flex flex-center">
              <q-pagination
                v-model="data.pagination.current"
                :max="data.pagination.max"
                input
                @update:model-value="loadThis(getListArtikel)"
              />
            </div>
          </q-card-section>

          <q-card-section
            class="col-4 q-px-md q-gutter-y-md q-my-xm column l-grow"
          >
            <div class="row text-right items-center">
              <div style="font-size: 14px">
                <b>{{ data.selectedArtikel.length }}</b> Artikel yang
                ditambahkan
              </div>
              <q-space />
              <q-btn
                class="text-weight-bold bg-white"
                outline
                no-caps
                unelevated
                color="dark"
                label="Kosongkan"
                @click="deleteAll"
              ></q-btn>
            </div>
            <q-scroll-area class="l-grow">
              <div class="column q-gutter-y-sm">
                <div
                  v-for="(item, idx) in data.selectedArtikel"
                  :key="idx"
                  class="bg-white row items-center"
                  style="border-radius: 4px"
                >
                  <q-img
                    :src="`${item.img.indexOf('http') > -1 ? '' : imgURL}${
                      item.img
                    }`"
                    class="q-ma-sm"
                    width="48px"
                  >
                  </q-img>
                  <div>{{ item.no }} {{ item.varian }}</div>
                  <q-space />
                  <q-btn
                    class="q-ma-sm"
                    flat
                    color="brand"
                    icon="delete"
                    @click="deleteSelectedArtikel(idx)"
                  />
                </div>
              </div>
            </q-scroll-area>
            <div class="q-pa-sm row justify-center">
              <q-btn
                class="text-weight-bold q-py-sm q-px-xl"
                no-caps
                unelevated
                color="brand"
                v-close-popup
                label="Submit"
                @click="addArtikeltoList"
                :disable="data.selectedArtikel.length == 0"
              ></q-btn>
            </div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- dialog masukkan ratio -->
    <q-dialog v-model="openDialogRatio" persistent>
      <q-card class="my-font">
        <q-toolbar class="row justify-end q-pb-none">
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section class="text-center q-pt-none">
          <div class="text-h6 text-bold">Masukkan Ratio</div>
          <div class="row q-pa-lg flex flex-center q-gutter-x-sm">
            <q-input
              autofocus
              ref="ratio_0"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[0]"
              style="width: 50px"
              @focus="ratio_0.select()"
              @update:model-value="ratio_1.focus()"
            />
            <q-input
              ref="ratio_1"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[1]"
              style="width: 50px"
              @focus="ratio_1.select()"
              @update:model-value="ratio_2.focus()"
            />
            <q-input
              ref="ratio_2"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[2]"
              style="width: 50px"
              @focus="ratio_2.select()"
              @update:model-value="ratio_3.focus()"
            />
            <q-input
              ref="ratio_3"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[3]"
              style="width: 50px"
              @focus="ratio_3.select()"
              @update:model-value="ratio_4.focus()"
            />
            <q-input
              ref="ratio_4"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[4]"
              style="width: 50px"
              @update:model-value="ratio_5.focus()"
              @focus="ratio_4.select()"
            />
            <q-input
              ref="ratio_5"
              input-class="text-center"
              type="number"
              outlined
              dense
              maxlength="1"
              placeholder="0"
              v-model.number="ratio[5]"
              style="width: 50px"
              @update:model-value="btnsubmit.$el.focus()"
              @focus="ratio_5.select()"
            />
          </div>
        </q-card-section>

        <q-card-actions align="center" class="q-pt-none q-pb-md">
          <q-btn
            class="text-weight-bold q-py-sm q-px-xl"
            unelevated
            no-caps
            text-color="white"
            label="Submit"
            color="brand"
            v-close-popup
            @click="setRatio"
            ref="btnsubmit"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- dialog simpan -->
    <q-dialog v-model="openDialogSimpan" persistent>
      <q-card class="my-font" style="max-width: 400px; width: 340px">
        <q-toolbar class="row justify-end">
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section class="text-center column q-gutter-y-sm">
          <div class="column items-center">
            <div
              class="q-pa-md bg-green-2"
              style="
                border-radius: 100%;
                aspect-ratio: 1 / 1;
                width: fit-content;
              "
            >
              <q-icon name="check_circle_outline" size="3em" color="positive" />
            </div>
            <!-- <q-img :src="`/img/green-check.png`" width="56px"/> -->
          </div>
          <div class="text-h6 text-bold">
            Apakah Anda yakin ingin menyimpan {{ data.rows.length }} data?
          </div>
          <div class="text-grey-8">
            Pastikan kembali semua data yang Anda masukan sudah benar
          </div>
        </q-card-section>

        <q-card-actions align="center" class="bg-grey-2 q-py-md">
          <q-btn
            class="bg-white text-bold q-pa-md"
            outline
            no-caps
            dense
            label="Check Kembali"
            color="dark"
            v-close-popup
          />
          <q-btn
            class="text-bold q-pa-md"
            unelevated
            no-caps
            dense
            text-color="white"
            label="Ya, Simpan"
            color="brand"
            @click="waitThis(postInboundItem)"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- dialog keluar -->
    <q-dialog v-model="openDialogKeluar" persistent>
      <q-card class="my-font" style="max-width: 400px; width: 340px">
        <q-toolbar class="row justify-end">
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section class="text-center column q-gutter-y-sm">
          <div class="column items-center">
            <div
              class="q-pa-md bg-red-2"
              style="
                border-radius: 100%;
                aspect-ratio: 1 / 1;
                width: fit-content;
              "
            >
              <q-icon name="error_outline" size="3em" color="negative" />
            </div>
            <!-- <q-img :src="`/img/red-warning.png`" width="56px"/> -->
          </div>
          <div class="text-h6 text-bold">Apakah Anda yakin ingin keluar?</div>
          <div class="text-grey-8">
            Jika Anda keluar, maka perubahan yang belum disimpan akan dihapus
          </div>
        </q-card-section>

        <q-card-actions align="center" class="bg-grey-2 q-py-md">
          <q-btn
            class="bg-white text-bold q-pa-md"
            outline
            no-caps
            dense
            label="Batalkan"
            color="dark"
            v-close-popup
          />
          <q-btn
            class="text-bold q-pa-md"
            unelevated
            no-caps
            dense
            text-color="white"
            label="Ya, Keluar"
            color="red"
            @click="data.isClickFooterButton = true"
            to="/inbound"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import useBasic from "@/composables/useBasic";
import { onBeforeRouteLeave } from "vue-router";

export default {
  name: "MakeInBoundView",
  setup() {
    const {
      ref,
      onMounted,
      reactive,
      loadThis,
      $http,
      imgURL,
      moment,
      router,
      route,
      onBeforeUnmount,
      waitThis,
    } = useBasic();

    let data = reactive({
      rows: [],
      gudang: "Gudang Pusat",
      rowsArtikel: [],
      selectedArtikel: [],
      diterima: "",
      noDok: "",
      keterangan: "",
      cariProduk: "",
      pagination: {
        current: 1,
        max: 1,
        limit: 10,
      },
      isDetail: route.params.id_inbound != "",
      oriPayload: "",
      isClickFooterButton: false,
    });

    onBeforeRouteLeave((to, from, next) => {
      let temp = {
        rows: data.rows,
        noDok: data.noDok,
        diterima: data.diterima,
        keterangan: data.keterangan,
      };
      let str = JSON.stringify(temp);

      if (data.oriPayload !== str && !data.isClickFooterButton) {
        const answer = window.confirm(
          "Apa anda yakin ingin meninggalkan halaman ini? Perubahan tidak akan tersimpan!"
        );
        if (answer) {
          next();
        } else {
          next(false);
        }
      } else {
        next();
      }
    });

    let refRatio1 = ref(null);

    const openDialogRatio = ref(false);
    const openDialog = ref(false);
    const openDialogSimpan = ref(false);
    const openDialogKeluar = ref(false);
    const ratioIdx = ref(null);
    const ratio = ref([0, 0, 0, 0, 0, 0]);
    let btnsubmit = ref(null);
    let ratio_0 = ref(null);
    let ratio_1 = ref(null);
    let ratio_2 = ref(null);
    let ratio_3 = ref(null);
    let ratio_4 = ref(null);
    let ratio_5 = ref(null);

    // ########## FUNCTION ##################
    function dialogRatio(idx) {
      openDialogRatio.value = true;
      ratioIdx.value = idx;
      ratio.value[0] = data.rows[ratioIdx.value].ratio[0];
      ratio.value[1] = data.rows[ratioIdx.value].ratio[1];
      ratio.value[2] = data.rows[ratioIdx.value].ratio[2];
      ratio.value[3] = data.rows[ratioIdx.value].ratio[3];
      ratio.value[4] = data.rows[ratioIdx.value].ratio[4];
      ratio.value[5] = data.rows[ratioIdx.value].ratio[5];
    }

    function sliceData(data, page, rowsPerPage) {
      return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    }

    function addArtikel(no, varian, img) {
      const newItem = {
        no: no,
        varian: varian,
        img: img,
      };
      data.selectedArtikel.push(newItem);
    }

    function deleteAll() {
      data.selectedArtikel = [];
    }

    function deleteSelectedArtikel(index) {
      data.selectedArtikel.splice(index, 1);
    }

    function deleteArtikelItem(index) {
      data.rows.splice(index, 1);
    }

    function setRatio() {
      data.rows[ratioIdx.value].ratio = ratio.value.join("");
      ratio.value = [0, 0, 0, 0, 0, 0];
    }

    function addArtikeltoList() {
      data.selectedArtikel.forEach((element) => {
        const newItem = {
          id_ratio: 1,
          article_code: element.no + element.varian,
          qty: null,
          starting_size: null,
          remarks: "",
          ratio: [0, 0, 0, 0, 0, 0].join(""),
        };
        data.rows.push(newItem);
      });

      data.selectedArtikel = [];
    }

    let postInboundItem = async () => {
      let payload = {
        id_supplier: 1,
        id_staff: route.params.id_staff,
        remarks: data.keterangan,
        no_dokumen: data.noDok,
        received_at: moment(data.diterima).format("YYYY-MM-DD HH:mm:ss"),
        good_receipt_details: data.rows,
      };

      await $http.post(`/inbound/store-article`, payload);
      data.isClickFooterButton = true;
      router.push("/inbound");
    };

    let getListArtikel = async () => {
      let resp = await $http.get(
        `/inbound/list-sku?current=${data.pagination.current}&limit=${data.pagination.limit}&search=${data.cariProduk}`
      );
      data.rowsArtikel = resp.data.rows;
      data.pagination.max = Math.ceil(
        resp.data.max_rows / data.pagination.limit
      );
    };

    let getInbound = async () => {
      let resp = await $http.get(`/inbound/single/${route.params.id_inbound}`);

      data.rows = resp.data.good_receipt_details;
      data.noDok = resp.data.no_dokumen;
      data.diterima = moment(resp.data.received_at).format("YYYY/MM/DD");
      data.keterangan = resp.data.remarks;
    };

    onMounted(async () => {
      if (route.params.id_inbound) {
        await loadThis(getInbound);
      } else {
        data.diterima = moment().format("YYYY/MM/DD");
        await loadThis(getListArtikel);
      }
      let temp = {
        rows: data.rows,
        noDok: data.noDok,
        diterima: data.diterima,
        keterangan: data.keterangan,
      };
      data.oriPayload = JSON.stringify(temp);
    });

    return {
      data,
      openDialog,
      openDialogSimpan,
      openDialogKeluar,
      openDialogRatio,
      ratio,
      ratioIdx,
      btnsubmit,
      ratio_0,
      ratio_1,
      ratio_2,
      ratio_3,
      ratio_4,
      ratio_5,
      imgURL,
      loadThis,
      route,
      router,
      refRatio1,
      sliceData,
      addArtikel,
      deleteAll,
      deleteSelectedArtikel,
      deleteArtikelItem,
      setRatio,
      dialogRatio,
      addArtikeltoList,
      postInboundItem,
      getListArtikel,
      optDate(date) {
        return date <= moment().format("YYYY/MM/DD");
      },
      waitThis,
    };
  },
};
</script>

<style>
.q-table thead th {
  font-size: 13px;
}
</style>
